import { getCookie, setCookie } from '../../../DAL/storage-provider';
import { getJSONFromHtml } from '../../../domain/common';
import { getHiddenDataBoolean, getHiddenDataString } from '../../../domain/hidden-data-provider';
import { format } from 'date-fns';

export const GDRP_COOKIE_NAME = 'gdpr';

export interface IGdpr {
    IsCountryGDPR: string, // "y", "n", "u"
    IsMarketing: boolean,
    IsPerformance: boolean,
    ItemModifiedWhen: string, // "2022-07-31T12:57:15.7440792"
}

/**
 * In case GDPR cookie doesn't exist, we rely on "IsGDPRDefaultOptOut" returned from SP.
 * If user is opt out ---> both IsMarketing and IsPerformance are false.
 * If user is not opt out ---> both IsMarketing and IsPerformance are true.
 * https://g6a420.axshare.com/#g=1&p=scripts_per_cookie_flow
 */
export const getGdprDefaultValues = () : IGdpr => {
    const isOptOut = isGdprOptOut();

    return {
        IsMarketing: !isOptOut,
        IsPerformance: !isOptOut,
        ItemModifiedWhen: format(new Date(), 'MM/dd/yyyy HH:mm:ss'),
        IsCountryGDPR: getHiddenDataString('gdpr-country') || 'u',
    } as IGdpr;
};

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-4442
 * https://g6a420.axshare.com/#g=1&p=scripts_per_cookie_flow
 */
export const getGdprCookie = () : IGdpr => {
    const cookie = getCookie(GDRP_COOKIE_NAME);
    if(!cookie) return getGdprDefaultValues();

    let parsed: IGdpr | null = null;

    try{
        parsed = JSON.parse(cookie) as IGdpr;
    }
    catch(ex){}

    return parsed || getGdprDefaultValues();
};


export const setGDPRCookie = (data: IGdpr) => {

    const expiration = -1;
    const secure = false;
    const sameSite = undefined;
    const preventStringify = false;
    const domain = '.waves.com';

    setCookie('gdpr', data, expiration, secure, sameSite, preventStringify, domain);
};

export const getGdprCookieFromServer = () : IGdpr => {
    return getJSONFromHtml(document.getElementById('cookies-policy-data-json')) as IGdpr;
};

export const isGdprOptOut = () : boolean => {
    return getHiddenDataBoolean('gdpr-opt-out');
};

/**
 * <div class="msg-box text-left mb-12">You may find this content helpful: To be able to view it, <a href="/legal/cookie-policy" target="_top" title="">allow Performance Cookies here</a>.</div>
 */
export const getGdprError = () => {
    const $error = document.getElementById('gdpr-error');
    return ($error?.textContent || '').trim();
};